import React, { useEffect } from 'react';
import Form from '../../components/form/Form';
import Swal from 'sweetalert2';
import groupService from '../../services/api/groupService';
import { Button, Input, Select, TextArea } from 'semantic-ui-react';
import { errorInput, textArea, searchSelectProps } from '../../components/helpers';
import { habeasData } from '../../components/helpers/habeasData';
import {
  useRecaptchaToken,
  isCaptchaRequired,
  RECAPTCHA_SECURITY_ERROR,
} from '../../components/helpers/recaptchaUtils';
import { questions } from '../../containers/groups/prospectLeaders/questions';
import styled from '@emotion/styled';
import SignatureCanvas from 'react-signature-canvas';
import { screenSizes } from 'src/assets/styles/Literals';

const FormComp = styled('div')`
  width: 80%;
  max-width: ${screenSizes.desktop};
  margin: 0 auto;
  padding: 2rem;

  .Registration__form {
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    padding: 2rem;
  }

  .form-prospect {
    max-width: 800px;
    margin: 0 auto;

    p {
      text-align: justify;
      line-height: 1.6;
      color: #333;
      margin-bottom: 1rem;
    }
  }

  p.disciple-name {
    font-weight: 700;
    text-align: center;
    font-size: 2.5rem;
    color: #2c3e50;
    margin: 1.5rem 0;
  }

  h1 {
    font-size: 2.2rem;
    color: #2c3e50;
    margin-bottom: 1.5rem;
    text-align: center;
  }

  h2 {
    margin: 2rem 0 1rem 0;
    color: #2c3e50;
    font-size: 1.8rem;
    font-weight: 600;
  }

  h4 {
    color: #666;
    margin: 1.5rem 0;
    font-weight: 500;
  }

  label {
    margin: 1rem 0 0.5rem 0;
    display: block;
    color: #444;
    font-weight: 500;
  }

  .error {
    color: #dc3545;
    font-size: 0.875rem;
    margin-top: 0.25rem;
  }

  #transversal {
    textarea {
      &.error {
        border: 2px solid #dc3545;
        background-color: #fff8f8;
        border-radius: 4px;
      }
    }
  }

  .sign {
    margin: 2rem 0;
    text-align: center;

    p {
      margin-bottom: 1rem;
      color: #444;
    }

    .sigCanvas {
      border: 2px solid #e0e0e0;
      border-radius: 8px;
      background: white;
      margin: 1rem auto;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

      &.error {
        border-color: #dc3545;
        background-color: #fff8f8;
      }
    }

    button {
      margin: 1rem auto;
      display: block;
      transition: all 0.2s ease;

      &:hover {
        transform: translateY(-1px);
      }
    }
  }

  .ui.button {
    margin: 1.5rem 0.5rem 0 0.5rem;
    transition: all 0.2s ease;

    &:hover {
      transform: translateY(-1px);
    }
  }

  .ui.input {
    width: 100%;
    margin-bottom: 1rem;
  }

  .ui.selection.dropdown {
    width: 100%;
    margin-bottom: 1rem;
  }

  @media screen and (max-width: 950px) {
    width: 90%;
    padding: 1rem;
  }

  @media screen and (max-width: 750px) {
    width: 100%;
    padding: 0.5rem;

    .Registration__form {
      padding: 1rem;
    }

    h1 {
      font-size: 1.8rem;
    }

    p.disciple-name {
      font-size: 2rem;
    }

    h2 {
      font-size: 1.5rem;
    }

    .sign {
      .sigCanvas {
        width: 100% !important;
        max-width: 300px;
      }
    }
  }
`;

const ProspectLeadersForm = (props) => {
  const [Attendant, set_Attendant] = React.useState({});
  const [inputs, set_Inputs] = React.useState({});
  const [errorInputs, set_errorInputs] = React.useState({});
  const [sent, set_sent] = React.useState(false);
  const [sending, set_sending] = React.useState(false);
  const [loading, set_loading] = React.useState('Cargando...');
  const getCaptchaToken = useRecaptchaToken('prospect_leader');
  const captchaRequired = isCaptchaRequired();

  const { hexaCode } = props.match.params;

  const canvasSign = React.useRef(null);

  const verifyForm = () => {
    let errorInputs = {};

    let attendantMandatoryInputs = [];

    if (hexaCode) {
      attendantMandatoryInputs = ['name', 'lastName', 'identification', 'phone'];
    }

    attendantMandatoryInputs.forEach((input) => {
      errorInputs = errorInput({
        errorInputs,
        input: { name: input, value: Attendant[input] },
      });
    });

    const mandatoryInputs = Object.values(
      hexaCode ? questions?.prospect : questions?.prospect_leader
    )
      ?.map((a) => a.id)
      .filter((a) => !!a);

    mandatoryInputs.forEach((input) => {
      errorInputs = errorInput({
        errorInputs,
        input: { name: input, value: inputs[input] },
      });
    });

    errorInputs = errorInput({
      errorInputs,
      input: {
        name: 'sign',
        value: canvasSign.current && !canvasSign.current.isEmpty(),
      },
    });

    if (Attendant['identification'] && Attendant['identification'].length <= 5) {
      errorInputs = errorInput({
        errorInputs,
        input: {
          name: 'identification',
          value: Attendant['identification'].length >= 5,
        },
      });
    }

    if (Attendant['phone'] && Attendant['phone'].length <= 10) {
      errorInputs = errorInput({
        errorInputs,
        input: {
          name: 'phone',
          value: Attendant['phone'].length >= 10,
        },
      });
    }

    set_errorInputs(errorInputs);
    return Object.values(errorInputs).includes(true);
  };

  let sendForm = async (e) => {
    e.preventDefault();
    if (verifyForm()) return;

    const signature = canvasSign.current;
    if (!signature || signature.isEmpty()) {
      set_errorInputs((prev) => ({ ...prev, sign: true }));
      return;
    }
    const sign = JSON.stringify(signature.toData().flat());

    set_sending(true);
    const captcha = await getCaptchaToken({ skip: !captchaRequired });
    if (captchaRequired && !captcha) {
      set_sending(false);
      Swal.fire(RECAPTCHA_SECURITY_ERROR);
      return;
    }

    let body = {
      Attendant,
      inputs: { ...inputs, captcha },
      sign,
      hexaCode: hexaCode,
    };
    groupService
      .sendProspectLeaders(body)
      .then((response) => {
        set_sending(false);
        if (response.data.success) {
          set_sent(true);
        }
        Swal.fire(response?.data?.message);
      })
      .catch((error) => {
        set_sending(false);
        Swal.fire(error?.response?.data?.message);
      });
  };

  let getAttendant = (e) => {
    if (hexaCode) {
      let body = { hexaCode };
      groupService
        .getProspectLeader(body)
        .then((response) => {
          set_loading('');
          if (response.data.success) {
            set_Attendant({ ...(response.data.prospectLeader?.Guest || {}) });
          }
        })
        .catch((error) => {
          set_loading(error?.response?.data?.message);
        });
    } else {
      set_loading('');
    }
  };

  useEffect(() => getAttendant(), []);

  const handleAttendant = (event) => {
    const { name, value } = event.target;
    set_Attendant({ ...Attendant, [name]: value });
    set_errorInputs((prev) => ({ ...prev, [name]: false }));
  };

  const handleInputs = (event) => {
    const { name, value } = event.target;
    set_Inputs({ ...inputs, [name]: value });
    set_errorInputs((prev) => ({ ...prev, [name]: false }));
  };

  const showQuestions = (questions) =>
    questions.map((question) => {
      if (question.type === 'title') {
        return <h2>{question?.text}</h2>;
      }
      if (question.type === 'text') {
        return <p>{question?.text}</p>;
      }
      if (question.type === 'select') {
        return (
          <div>
            <label
              style={{ display: 'block' }}
              className={`${errorInputs[question.id] ? 'error' : ''}`}
              htmlFor={question.id}
            >
              {question.text}
            </label>
            <Select
              label={question.text}
              className={`${errorInputs[question.id] ? 'error' : ''}`}
              disabled={sending}
              loading={sending}
              {...searchSelectProps({
                name: question.id,
                value: inputs[question.id],
                handler: (a, { value }) => set_Inputs({ ...inputs, [question.id]: value }),
                options: question.options.map((option) => ({
                  key: option,
                  text: option,
                  value: option,
                })),
              })}
            />
          </div>
        );
      }
      if (question.type === 'textArea') {
        return (
          <div>
            <label
              style={{ display: 'block' }}
              className={`${errorInputs[question.id] ? 'error' : ''}`}
              htmlFor={question.id}
            >
              {question.text}
            </label>
            {textArea({
              TextArea,
              label: question.text,
              name: question.id,
              disabled: sending,
              value: inputs[question.id],
              handler: (event) => handleInputs(event),
              loading: sending,
              errorInputs,
            })}
          </div>
        );
      }
      if (question.type === 'input') {
        return (
          <div>
            <label
              style={{ display: 'block' }}
              className={`${errorInputs[question.id] ? 'error' : ''}`}
              htmlFor={question.id}
            >
              {question.text}
            </label>
            <Input
              name={question.id}
              placeholder={question.text}
              className={`${errorInputs[question.id] ? 'error' : ''}`}
              disabled={sending}
              type={question.kind === 'number' ? 'number' : 'text'}
              value={inputs[question.id]}
              onChange={(event) => handleInputs(event)}
              loading={sending}
            />
          </div>
        );
      }
      if (question.type === 'form') {
        return (
          <>
            <h2>{question?.text}</h2>
            <Form
              Attendant={Attendant}
              handleInputs={handleAttendant}
              errorInputs={errorInputs}
              setAttendant={set_Attendant}
              setErrorInputs={set_errorInputs}
              onGuestUpdated={() => getAttendant()}
            />
          </>
        );
      }
      return null;
    });

  if (loading)
    return (
      <FormComp>
        <div className="Registration__form">{loading && <h1>{loading}</h1>}</div>
      </FormComp>
    );

  if (sent) {
    return (
      <FormComp>
        <div className="Registration__form">
          {hexaCode ? (
            <>
              <h1>¡Gracias {Attendant.name}!</h1>
              <p>
                Agradecemos profundamente tu sinceridad y el tiempo que has dedicado para responder
                a cada pregunta. El siguiente paso en el proceso es validar tus respuestas con el
                área de discipulado y con tu líder. Si continúas avanzando, se te programará una
                entrevista, ya sea de forma presencial o virtual, para completar el proceso.
              </p>
            </>
          ) : (
            <>
              <h1>¡Gracias {inputs.leader_name}!</h1>
              <p>
                Te agradecemos profundamente por tu sinceridad y el tiempo dedicado a responder cada
                pregunta. El siguiente paso en el proceso es validar tus respuestas con el área de
                discipulado. Si el postulante continúa avanzando en el proceso, se le enviará una
                encuesta adicional para completar la evaluación.
              </p>
            </>
          )}
          <p>En caso contrario, te informaremos sobre los próximos pasos a seguir.</p>
        </div>
      </FormComp>
    );
  }

  return (
    <FormComp>
      <div className="Registration__form">
        <>
          <h1>
            Bienvenid{Attendant.gender === 'Femenino' ? 'a' : 'o'} {Attendant.name}
          </h1>
          {Object.values(errorInputs).includes(true) && (
            <h4 style={{ color: 'red' }}>Por favor verifica los campos en rojo.</h4>
          )}
          <div className="form-prospect">
            {hexaCode
              ? showQuestions(questions.prospect)
              : showQuestions(questions.prospect_leader)}
          </div>
          <div className="sign">
            <p>Tu firma</p>
            <SignatureCanvas
              penColor="black"
              ref={canvasSign}
              canvasProps={{
                width: 300,
                height: 200,
                className: `sigCanvas  ${errorInputs['sign'] ? 'error' : ''}`,
              }}
            />
            <p>
              <strong>
                {hexaCode ? (
                  <>
                    {Attendant.name} {Attendant.lastName}
                  </>
                ) : (
                  inputs?.leader_name
                )}
              </strong>
            </p>
            <Button
              style={{ display: 'block', margin: '7px auto' }}
              size="mini"
              onClick={() => canvasSign.current?.clear()}
            >
              Limpiar firma
            </Button>
          </div>
          {habeasData}
          {Object.values(errorInputs).includes(true) && (
            <h4 style={{ color: 'red' }}>Todos los campos son obligatorios.</h4>
          )}
          <Button onClick={(e) => sendForm(e)} primary disabled={sending}>
            Enviar
          </Button>
        </>
      </div>
    </FormComp>
  );
};

export default ProspectLeadersForm;
